import "./Projects.css";

export default function Projects() {
  const projects = [
    {
      id: 5,
      year: 2026,
      title: "Standings",
      desc: "A website to check live standings for the sports I follow: F1, MotoGP, Valorant esports, and the Premier League, all in one place.",
      image: "/standings.png",
      tags: ["Vite", "FastAPI", "Python", "MongoDB", "Public APIs", "Web Scraping"],
      link: "https://standings-36tb.onrender.com/f1",
      demo: true,
    },
    {
      id: 1,
      year: 2025,
      title: "SpringMQ",
      desc: "A message queuing system built with Spring Boot that enables reliable and scalable communication between Order Service and Inventory Service in microservices architecture.",
      image: "/springmq.png",
      tags: ["Java", "Spring Boot", "RabbitMQ", "Microservices"],
      link: "https://github.com/sahill3/spring-mq/",
    },
    {
      id: 2,
      title: "Rosa, the AI Shopping Assistant",
      year: 2025,
      desc: "An AI-powered shopping assistant that helps users find products, compare prices, and make smarter purchase decisions using intelligent recommendations and real-time insights.",
      image: "/rosa.png",
      tags: ["FastAPI", "MongoDB", "Gemini 3.0", "LangGraph", "Docker"],
      link: "https://chatrosa.tech/",
      demo: true,
    },
    {
      id: 3,
      year: 2024,
      title: "Virtual Keyboard",
      desc: "A web-based virtual keyboard application that allows users to type using an on-screen keyboard, without physical touch input. Useful in times like the pandemic.",
      image: "/virtual-keyboard.png",
      tags: ["Python", "OpenCV", "Matplotlib", "Pillow"],
      link: "https://github.com/sahill3/virtual-keyboard",
    },
    {
      id: 4,
      title: "Coming soon!",
      year: 2025,
      desc: "",
      image: "/comingsoon.png",
      tags: ["Something cool"],
      link: "#",
    },
  ];

  return (
    <div className="projects-grid">
      {projects.map((p, index) => (
          <div className="project-card" style={{"--i": index}}>
            <div className="project-left">
              <img
                src={p.image}
                alt={p.title}
                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/comingsoon.png"; }}
              />
            </div>
            <div className="project-right">
              <div className="title-row">
                <h2>{p.title}</h2>
                <span className="year">{p.year}</span>
              </div>
              <div className="tags">
                {p.tags.map((t, i) => (
                  <span key={i} className="tag">{t}</span>
                ))}
              </div>
              <p className="desc">{p.desc}</p>
              <a href={p.link} target="_blank" rel="noreferrer" className="project-link">
                🔗 {p.demo ? "View Demo" : "View Project"}
              </a>
            </div>
          </div>
      ))}
    </div>
  );
}
